<div class="page-content loginback">
    <br>
    <br>
    <div class="container-md1">
        <div class="row" style="margin: 1%; color: white">
          
        
        
            <div class="col-12 text-center" style="padding-left: 10%; padding-right: 10%">
              <br>
              <h6>SELECT YOUR ACCOUNT ID :</h6>
              <br />
              <select
                style="text-align: center;
                  border: 1px solid #ffff;
                  box-shadow: 0px 5px 10px 0px #20b2aa;
                  cursor: pointer;
                "
                [(ngModel)]="b_acct_id"
                class="form-control"
                (change)="changeaccountprev(b_acct_id)"
              >
                <option
                  style="background-color: rgb(241 205 248 / 30%); color: black"
                  *ngFor="let item of Security.accountlist"
                  [value]="item.b_acct_id"
                >
                  {{ item["acct_desc"] }}
                </option>
              </select>
              <br /><br />
              <button
                style="
                  border: 1px solid #ffff;
                  box-shadow: 0px 5px 10px 0px #20b2aa;
                  cursor: pointer;
                "
                type="button"
                class="btn btn-primary"
                (click)="SubmitAccountfinal()"
              >
                Submit</button
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <button
                style="
                  border: 1px solid #ffff;
                  box-shadow: 0px 5px 10px 0px #20b2aa;
                  cursor: pointer;
                "
                type="button"
               
                class="btn btn-danger"
                (click)="goback()"
              >
                Cancel
              </button>
             
        
            </div>
          </div>


    </div>

</div>
